var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPause = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .pause-class-a {\n                fill: none !important;\n            }\n\n            .pause-class-b,\n            .pause-class-c {\n                fill: #fff;\n            }\n\n            .pause-class-b {\n                fill-rule: evenodd;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "pause-class-a",
    width: 44,
    height: 44
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.705 4.684)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pause-class-b",
    d: "M119.858,379.152a14.294,14.294,0,1,0,14.294-14.294A14.294,14.294,0,0,0,119.858,379.152Zm-2.858,0A17.152,17.152,0,1,0,134.152,362,17.153,17.153,0,0,0,117,379.152Z",
    transform: "translate(-117 -362)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.349 10.977)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pause-class-c",
    d: "M12,19.1H9.338A.324.324,0,0,1,9,18.791V7.059a.324.324,0,0,1,.338-.309H12a.324.324,0,0,1,.338.309V18.791A.324.324,0,0,1,12,19.1Z",
    transform: "translate(-9 -6.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pause-class-c",
    d: "M24.379,19.1H21.713a.324.324,0,0,1-.338-.309V7.059a.324.324,0,0,1,.338-.309h2.666a.324.324,0,0,1,.338.309V18.791A.324.324,0,0,1,24.379,19.1Z",
    transform: "translate(-14.838 -6.75)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_pause.77024a5c886e35de04ed62f124ff0a66.svg";